

import { Vue, Component, Prop } from 'vue-property-decorator'
@Component
export default class HonjoLogo extends Vue {
  @Prop(Boolean) expand!: boolean

  @Prop(String) title!: string

  get collapseCls () {
    return this.expand ? '' : 'honjo-logo--collpase'
  }
}
